import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@e2n/ui';
import { useFristenContext } from '@/domain/mitarbeiter/features/anlageassistent/content/Anstellungsverhaeltnis/Fristen/context/useFristenContext';

import {
  faEllipsisV,
  faPenToSquare,
  faTrashCan,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function FristenActions({
  index,
  className,
}: {
  index: number;
  className?: string;
}) {
  const { t } = useTranslation();
  const { setOpenEditSheet, setFristIndex, setOpenDeleteDialog } =
    useFristenContext();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className={className}>
        <FontAwesomeIcon
          icon={faEllipsisV}
          className="text-primary-blue-600 ml-auto"
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem
          className="flex gap-2"
          onClick={() => {
            setOpenEditSheet(true);
            setFristIndex(index);
          }}>
          <FontAwesomeIcon icon={faPenToSquare} />
          <span>
            {t(
              'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.editFristDialog.buttonLabel',
            )}
          </span>
        </DropdownMenuItem>

        <DropdownMenuItem
          className="flex gap-2 text-primary-red-500"
          onClick={() => {
            setOpenDeleteDialog(true);
            setFristIndex(index);
          }}>
          <FontAwesomeIcon icon={faTrashCan} />
          <span>
            {t(
              'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.deleteFristDialog.buttonLabel',
            )}
          </span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
